import { type ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

/**
 * Custom tailwind-merge — Claude Design 시맨틱 fontSize 토큰 등록
 * (tailwind.config.js `fontSize` extend 와 동기화)
 * 등록 안 하면 `text-body-lg` 같은 클래스가 color 로 오인되어 `text-muted-foreground` 와 충돌로 제거됨.
 */
const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [
                { text: [
                    /* v2 canonical — display */
                    'display-2xl', 'display-xl', 'display-lg', 'display-md',
                    /* v2 canonical — heading / reading */
                    'heading', 'heading-sm', 'reading',
                    /* v2 canonical — body / label */
                    'body-lg', 'body', 'body-sm', 'label',
                    /* v2 canonical — meta / micro */
                    'meta', 'meta-sm', 'micro',
                    /* feature-specific */
                    'task-title',
                ] },
            ],
        },
    },
})

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}
